import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Chip,
  DialogActions,
  DialogContentText,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Tooltip
} from '@mui/material';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import IconButton from '@mui/material/IconButton';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Theme, styled, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDocumentUploads } from 'src/components/StartUp/documentUpload/useDocumentUploads';
import { ButtonComponent } from 'src/components/common/ButtonComponent';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { StackComponent } from 'src/components/common/StackComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useTab } from 'src/components/hooks/useTab';
import { useUser } from 'src/components/hooks/useUser';
import { getPoratlHost } from 'src/components/hooks/useUtil';
import { archLevel } from 'src/data/config';
import { setPath } from 'src/store/Navigation';
import { setIsBackButtonEnable } from 'src/store/SiteConatctInfo';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppSelector } from 'src/store/hooks';
import { formatInput } from 'src/util/STR';
import { DocumentUpload } from '../documentUpload/DocumentUpload';
import { useStartUpPacket } from './useStartUpPacket';

const docStatusOptions = ['Draft', 'Under review'];
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary
}));

const BootstrapDialogTitle = (props: { [x: string]: any; children: any; onClose: any }) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const menuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

function getStyles(name: string, personName: string[], theme: Theme) {
  return {
    fontWeight: personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium
  };
}

const ContractandBudget: React.FunctionComponent<any> = ({
  updateContractAndBudget,
  validationObj,
  contractBudget,
  setValidationObj,
  setContractBudget,
  contractBudgetrmData,
  setcontractBudgetrmData,
  updatedcontractBudgetrmData,
  setUpdatedcontractBudgetrmData,
  teamMembers
}) => {
  const { contractAndBuget } = useFieldTranslation();
  const dispatch = useDispatch();
  const [type, setType] = React.useState('');
  const [active2, setActive2] = useState(false);
  const [active, setActive] = useState(false);
  const [draftBtnDisplay, setDraftBtnDisplay] = useState('none');
  const [draftBtnDisplay2, setDraftBtnDisplay2] = useState('none');
  const [open1, setopen1] = React.useState(false);
  const anchorRef1: any = React.useRef(null);
  const anchorRef2: any = React.useRef(null);
  const [selectedIndex1, setSelectedIndex1] = React.useState(0);
  const [selectedIndex2, setSelectedIndex2] = React.useState(0);
  const [open2, setOpen2] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const { checkPermission } = usePermissionWrapper();
  const perDisable = checkPermission('update_contract_budget');
  const hideAddPersonel = checkPermission('create_site_personnel');
  const [contractUpDoc, setContractUpDoc] = useState<any>([]);
  const [budgetUpDoc, setBudgetUpDoc] = useState<any>([]);
  const { user } = useUser();
  const { setTabVal, tabsData } = useTab();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { getDocListBySiteLevelArtifact } = useStartUpPacket();
  const { getAllISFDocInfoByArtifactNumberSiteLevelData } = useDocumentUploads();

  const handleMenuItemClick1 = (_: any, index: any) => {
    setSelectedIndex1(index);
    setopen1(false);
    setcontractBudgetrmData({
      ...contractBudgetrmData,
      site_contract_status: docStatusOptions[index],
      created_by: user
    });

    setUpdatedcontractBudgetrmData({
      ...updatedcontractBudgetrmData,
      site_contract_status: docStatusOptions[index],
      updated_by: user
    });
    setConfirmExitValue(dispatch, true);
  };
  const handleMenuItemClick2 = (_: any, index: any) => {
    setSelectedIndex2(index);
    setOpen2(false);
    setcontractBudgetrmData({
      ...contractBudgetrmData,
      site_budget_agreement_status: docStatusOptions[index],
      created_by: user
    });

    setUpdatedcontractBudgetrmData({
      ...updatedcontractBudgetrmData,
      site_budget_agreement_status: docStatusOptions[index],
      updated_by: user
    });
    setConfirmExitValue(dispatch, true);
  };

  const handleToggle1 = () => {
    setopen1(prevopen => !prevopen);
  };
  const handleToggle2 = () => {
    setOpen2(prevOpen => !prevOpen);
  };
  const handleClose1 = (event: any) => {
    if (anchorRef1.current && anchorRef1.current.contains(event.target)) {
      return;
    }
    setopen1(false);
  };
  const handleClose2 = (event: any) => {
    if (anchorRef2.current && anchorRef2.current.contains(event.target)) {
      return;
    }
    setOpen2(false);
  };

  const getUploadedDocuments = async (artifactName: string, artifactNumber: any = null) => {
    const result: any =
      archLevel == 'sponsor'
        ? await getDocListBySiteLevelArtifact({
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            artifactName,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'START UP PACKET',
            parent_entity_related: ''
          })
        : await getAllISFDocInfoByArtifactNumberSiteLevelData({
            site_id: selectedSite,
            study_id: studyId,
            country: selectedCountry,
            artifactName,
            artifactNumber,
            originally_uploaded: false,
            application: process.env.REACT_APP_NAME,
            module_section_related: 'START UP PACKET',
            parent_entity_related: ''
          });
    if (result.isSuccess) {
      const sortedDocsList =
        result?.data && result?.data?.selected_data.length > 0 ? getSortedDocsList(result?.data?.selected_data) : [];
      if (artifactName === 'Clinical Trial Agreement' || artifactName === 'Clinical trial agreement') {
        setContractUpDoc(sortedDocsList);
        setActive(true);
        setDraftBtnDisplay('inline-block');
      } else if (artifactName == 'Financial Documentation' || artifactName == 'Invoice') {
        setBudgetUpDoc(sortedDocsList);
        setActive2(true);
        setDraftBtnDisplay2('inline-block');
      }
    } else {
      if (artifactName === 'Clinical Trial Agreement') {
        setActive(false);
        setDraftBtnDisplay('none');
        setContractUpDoc([]);
      } else if (artifactName == 'Financial Documentation') {
        setActive2(false);
        setDraftBtnDisplay2('none');
        setBudgetUpDoc([]);
      }
    }
  };

  const getSortedDocsList = (result: any) => {
    const resultCopy = [...result];
    const checkDocList = resultCopy.sort(
      (a: any, b: any) => +new Date(a.document_data.created_on) - +new Date(b.document_data.created_on)
    );
    const oldestDoc = checkDocList[0];
    const listFiltered =
      archLevel == 'sponsor'
        ? result.filter((doc: any) => oldestDoc.document_data.tmf_document_id !== doc.document_data.tmf_document_id)
        : result.filter((doc: any) => oldestDoc.document_data.isf_document_id !== doc.document_data.isf_document_id);
    return [oldestDoc, ...listFiltered];
  };

  const openDoucmentViewer = (item: any) => {
    window.parent.postMessage(
      {
        action: 'PUSH_APP',
        slug_id: archLevel == 'site' ? process.env.REACT_APP_ISF_SLUG : process.env.REACT_APP_ETMF_SLUG,
        //Send Study ID, Country ID, Site ID along with Document ID and for the Site Level document viewing
        viewerDocument: {
          document_id: item.document_data.id,
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          ...(archLevel == 'site' && {
            file_master_id: item.file_master.id
          })
        }
      },
      getPoratlHost()
    );
  };

  const navigateToSitInfo = () => {
    dispatch(setPath('startupPacket'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'siteContactInfo');
    setTabVal(currentTabinfo[0].index);

    dispatch(setIsBackButtonEnable(true));
  };

  useEffect(() => {
    if (selectedSite !== '') {
      if (archLevel == 'sponsor') {
        getUploadedDocuments('Clinical Trial Agreement');
        getUploadedDocuments('Financial Documentation');
      } else {
        getUploadedDocuments('Clinical trial agreement', '02.01.02');
        getUploadedDocuments('Invoice', '02.05.01');
      }
    }
  }, [selectedSite]);

  const handleClickOpen = (typeData: string) => {
    if (typeData === 'Contract') {
      setType('Clinical Trial Agreement');
      setOpen(true);
    } else {
      setType('Financial Documentation');
      setOpen(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleVlidationObj = (propName: string) => {
    if (propName in validationObj) {
      const updatedValidatoinObj = {
        ...validationObj,
        [propName]: false
      };
      setValidationObj(updatedValidatoinObj);
    }
  };
  const updatePropWithValue = (propName: string, value: string) => {
    setContractBudget({
      ...contractBudget,
      [propName]: value
    });
    setcontractBudgetrmData({
      ...contractBudgetrmData,
      [propName]: value,
      site_id: selectedSite,
      study_id: studyId
    });
    setUpdatedcontractBudgetrmData({
      ...updatedcontractBudgetrmData,
      [propName]: value,
      site_id: selectedSite,
      study_id: studyId,
      updated_by: user
    });
  };
  const handleCheck = (e: any) => {
    const value = e.target.value;
    const formattedVal = typeof value === 'string' ? formatInput(value) : value;
    updatePropWithValue(e.target.name, formattedVal);
    handleVlidationObj(e.target.name);
    setConfirmExitValue(dispatch, true);
  };

  const theme = useTheme();

  const [responsibleContract, setResponsibleContract] = React.useState<string[]>(
    typeof contractBudgetrmData.site_responsible_contract === 'string'
      ? contractBudgetrmData.site_responsible_contract.split(',')
      : contractBudgetrmData.site_responsible_contract
  );

  const [responsiblePayment, setResponsiblePayment] = React.useState<string[]>(
    typeof contractBudgetrmData.site_payment_responsible === 'string'
      ? contractBudgetrmData.site_payment_responsible.split(',')
      : contractBudgetrmData.site_payment_responsible
  );

  const responsibleContractChange = (event: SelectChangeEvent<typeof responsibleContract>) => {
    const {
      target: { value }
    } = event;
    setResponsibleContract(typeof value === 'string' ? value.split(',') : value);
    updatePropWithValue(event.target.name, value.toString());
    handleVlidationObj(event.target.name);
    setConfirmExitValue(dispatch, true);
  };

  const responsiblePaymentChange = (event: SelectChangeEvent<typeof responsiblePayment>) => {
    const {
      target: { value }
    } = event;
    setResponsiblePayment(typeof value === 'string' ? value.split(',') : value);
    updatePropWithValue(event.target.name, value.toString());
    handleVlidationObj(event.target.name);
    setConfirmExitValue(dispatch, true);
  };

  useEffect(() => {
    setContractBudget({ ...contractBudget, site_id: selectedSite, study_id: studyId });
  }, [studyId]);

  useEffect(() => {
    if (archLevel == 'sponsor') {
      getUploadedDocuments('Clinical Trial Agreement');
      getUploadedDocuments('Financial Documentation');
    } else {
      getUploadedDocuments('Clinical trial agreement', '02.01.02');
      getUploadedDocuments('Invoice', '02.05.01');
    }
  }, []);

  return (
    <AccordionDetails className="contract-and-budget">
      <Typography>
        <Grid container className="checkbox-block">
          <Grid md={12}>
            <p>
              {contractAndBuget.header1}
              <span style={{ color: 'red' }}> *:</span>
            </p>
          </Grid>
          <Grid md={8} className="input-action">
            <FormControl
              fullWidth
              margin="normal"
              className="custom-date"
              error={validationObj.site_responsible_contract}
            >
              <InputLabel id="demo-multiple-name-label">{contractAndBuget.label1}</InputLabel>
              <Select
                sx={{ width: 250 }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                value={contractBudgetrmData.site_responsible_contract.split(',').filter(Boolean)}
                onChange={responsibleContractChange}
                input={<OutlinedInput label="Select from Contact List" />}
                MenuProps={menuProps}
                name="site_responsible_contract"
                disabled={!perDisable}
              >
                {teamMembers.map((option: any, index: number) => (
                  <MenuItem
                    key={index}
                    value={`${option}`}
                    style={getStyles(
                      `${option.site_per_last_name} ${option.site_per_first_name}`,
                      responsibleContract,
                      theme
                    )}
                  >
                    {`${option}`}
                  </MenuItem>
                ))}
              </Select>
              {validationObj.site_responsible_contract ? (
                <FormHelperText className="Mui-error">Required</FormHelperText>
              ) : (
                ''
              )}
            </FormControl>

            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <StackComponent spacing={3} direction="row" className="bottom-btn">
                  {hideAddPersonel && checkPermission('view_site_contact_info') && perDisable ? (
                    <ButtonComponent
                      variant="contained"
                      onClick={() => setOpenConfirmExit(true)}
                      endIcon={<OpenInNewIcon />}
                      sx={{ maxHeight: '41px' }}
                    >
                      ADD NEW SITE PERSONNEL
                    </ButtonComponent>
                  ) : (
                    ''
                  )}
                </StackComponent>
              </Grid>
            </Grid>
          </Grid>
          <Grid md={12} className="input-action">
            <div className="pw-formfield">
              <p>
                {contractAndBuget.label2} ?<span style={{ color: 'red' }}> *</span>
              </p>
              <FormControl className="radio-buttons-block">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="site_contract_reviewers"
                  className="radio-buttons"
                  onChange={handleCheck}
                  value={contractBudgetrmData.site_contract_reviewers}
                >
                  <FormControlLabel value="Y" control={<Radio />} label="Yes" disabled={!perDisable} />
                  <FormControlLabel value="N" control={<Radio />} label="No" disabled={!perDisable} />
                </RadioGroup>
              </FormControl>
            </div>
            <FormControl fullWidth margin="normal">
              <Item>
                <TextField
                  id="standard-disabled"
                  label="Description"
                  variant="standard"
                  name="site_contract_review_description"
                  value={contractBudgetrmData.site_contract_review_description}
                  error={validationObj.site_contract_review_description}
                  helperText={validationObj.site_contract_review_description ? 'Required' : ''}
                  onChange={handleCheck}
                  disabled={!perDisable}
                />
              </Item>
            </FormControl>
          </Grid>

          <Grid md={12} className="input-action">
            <p>
              What is the average duration to have a contract signed? <span style={{ color: 'red' }}> *</span>
            </p>
            <FormControl fullWidth margin="normal">
              <Item>
                <TextField
                  id="standard-disabled"
                  label="Description"
                  variant="standard"
                  name="site_contract_sign_duration"
                  value={contractBudgetrmData.site_contract_sign_duration}
                  error={validationObj.site_contract_sign_duration}
                  helperText={validationObj.site_contract_sign_duration ? 'Required' : ''}
                  onChange={handleCheck}
                  disabled={!perDisable}
                />
              </Item>
            </FormControl>
          </Grid>

          <Grid md={12} className="input-action">
            <p>
              {contractAndBuget.label3}? <span style={{ color: 'red' }}> *</span>
            </p>
            <FormControl fullWidth margin="normal">
              <Item>
                <TextField
                  id="standard-disabled"
                  label="Description"
                  variant="standard"
                  name="site_contract_requirements"
                  value={contractBudgetrmData.site_contract_requirements}
                  error={validationObj.site_contract_requirements}
                  helperText={validationObj.site_contract_requirements ? 'Required' : ''}
                  onChange={handleCheck}
                  disabled={!perDisable}
                />
              </Item>
            </FormControl>
          </Grid>

          <Grid md={12} className="input-action">
            <p>
              {contractAndBuget.label4}? <span style={{ color: 'red' }}> *</span>
            </p>
          </Grid>
          <Grid md={8} className="input-action">
            <FormControl
              fullWidth
              margin="normal"
              className="custom-date"
              error={validationObj.site_payment_responsible}
            >
              <InputLabel id="demo-multiple-name-label1">Select from Contact List</InputLabel>
              <Select
                sx={{ width: 250 }}
                labelId="demo-multiple-name-label1"
                id="demo-multiple-name"
                multiple
                value={contractBudgetrmData.site_payment_responsible.split(',').filter(Boolean)}
                onChange={responsiblePaymentChange}
                input={<OutlinedInput label="Select from Contact List" />}
                MenuProps={menuProps}
                name="site_payment_responsible"
                disabled={!perDisable}
              >
                {teamMembers.map((option: any, index: number) => (
                  <MenuItem
                    key={index}
                    value={`${option}`}
                    style={getStyles(
                      `${option.site_per_last_name} ${option.site_per_first_name}`,
                      responsiblePayment,
                      theme
                    )}
                  >
                    {`${option}`}
                  </MenuItem>
                ))}
              </Select>
              {validationObj.site_payment_responsible ? (
                <FormHelperText className="Mui-error">Required</FormHelperText>
              ) : (
                ''
              )}
            </FormControl>
            <Grid container spacing={2}>
              <Grid item md={12} display="flex" justifyContent="flex-end">
                <StackComponent spacing={3} direction="row" className="bottom-btn">
                  {hideAddPersonel && checkPermission('view_site_contact_info') && perDisable ? (
                    <ButtonComponent
                      variant="contained"
                      onClick={() => setOpenConfirmExit(true)}
                      endIcon={<OpenInNewIcon />}
                      sx={{ maxHeight: '41px' }}
                    >
                      ADD NEW SITE PERSONNEL
                    </ButtonComponent>
                  ) : (
                    ''
                  )}
                </StackComponent>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container className="modal-actions">
          <Grid md={12}>
            <div>
              <Tooltip title="Upload Document" placement="top" arrow>
                <IconButton
                  aria-label="add"
                  color="primary"
                  size="large"
                  onClick={() => handleClickOpen('Contract')}
                  disabled={!checkPermission('upload_contract_budget_docs')}
                >
                  <AddCircleIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
              <div className="btn-space">
                {contractUpDoc.length !== 0 ? (
                  checkPermission('view_startUp_packet') ? (
                    <Button className="modal-btn active" onClick={() => openDoucmentViewer(contractUpDoc[0])}>
                      Contract
                    </Button>
                  ) : (
                    <span className="disable-paragraph">Contract</span>
                  )
                ) : (
                  <span className="disable-paragraph">Contract</span>
                )}
              </div>
              {/* Draft button */}
              <ButtonGroup
                variant="contained"
                ref={anchorRef1}
                aria-label="split button"
                disabled={!checkPermission('doc_status_contract_budget')}
                style={{ display: draftBtnDisplay }}
              >
                <Button style={{ textTransform: 'capitalize' }} onClick={handleToggle1}>
                  {docStatusOptions[docStatusOptions.indexOf(contractBudgetrmData.site_contract_status)]}
                </Button>
                <Button
                  size="small"
                  aria-controls={open1 ? 'split-button-menu' : undefined}
                  aria-expanded={open1 ? 'true' : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle1}
                >
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              <Popper
                open={open1}
                anchorEl={anchorRef1.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-start"
              >
                {({ TransitionProps, placement }) => (
                  <Grow {...TransitionProps}>
                    <Paper elevation={4}>
                      <ClickAwayListener onClickAway={handleClose1}>
                        <MenuList id="split-button-menu">
                          {docStatusOptions.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={index === 2}
                              selected={index === selectedIndex1}
                              onClick={event => handleMenuItemClick1(event, index)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
              {/* Draft button ends here */}
              <div />
              {contractUpDoc.length > 1 ? (
                checkPermission('view_startUp_packet') ? (
                  contractUpDoc
                    .slice(1)
                    .map((item: any, index: number) => (
                      <Chip
                        sx={{ m: 0.3, maxWidth: '50%' }}
                        key={index}
                        label={
                          archLevel == 'sponsor'
                            ? item.document_data.tmf_document_name
                            : item.document_data.isf_document_name
                        }
                        variant="outlined"
                        onClick={() => openDoucmentViewer(item)}
                        size="small"
                        color="primary"
                      />
                    ))
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              <PopupComponent aria-labelledby="customized-dialog-title" open={open} maxWidth="md">
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                  Documents / Upload Document
                </BootstrapDialogTitle>
                <DialogContent>
                  <DocumentUpload
                    selectedSite={selectedSite}
                    type={type}
                    level="Site"
                    setOpen={setOpen}
                    open={open}
                    active={active}
                    setActive={setActive}
                    active2={active2}
                    setActive2={setActive2}
                    setDraftBtnDisplay={setDraftBtnDisplay}
                    setDraftBtnDisplay2={setDraftBtnDisplay2}
                    getUploadedDocuments={getUploadedDocuments}
                  />
                </DialogContent>
              </PopupComponent>
            </div>
          </Grid>
        </Grid>
        <PopupComponent
          open={openConfirmExit}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
          child
        >
          <DialogTitle id="alert-dialog-title">
            <b>Please Confirm</b>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              You will be redirected to Site Personnel Details section. Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setOpenConfirmExit(false);
              }}
              className="grey-btn"
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                navigateToSitInfo();
              }}
            >
              Proceed
            </Button>
          </DialogActions>
        </PopupComponent>
        <Grid container className="modal-actions">
          <Grid md={12}>
            <div>
              <Tooltip title="Upload Document" placement="top" arrow>
                <IconButton
                  aria-label="add"
                  color="primary"
                  size="large"
                  onClick={() => handleClickOpen('Budget Agreement')}
                  disabled={!checkPermission('upload_contract_budget_docs')}
                >
                  <AddCircleIcon fontSize="inherit" />
                </IconButton>
              </Tooltip>
              <div className="btn-space">
                {budgetUpDoc.length !== 0 ? (
                  checkPermission('view_startUp_packet') ? (
                    <Button className="modal-btn active" onClick={() => openDoucmentViewer(budgetUpDoc[0])}>
                      Budget Agreement
                    </Button>
                  ) : (
                    <span className="disable-paragraph">Budget Agreement</span>
                  )
                ) : (
                  <span className="disable-paragraph">Budget Agreement</span>
                )}
              </div>
              {/* Draft button 2 */}
              <ButtonGroup
                variant="contained"
                ref={anchorRef2}
                aria-label="split button"
                style={{ display: draftBtnDisplay2 }}
                disabled={!checkPermission('doc_status_contract_budget')}
              >
                <Button style={{ textTransform: 'capitalize' }} onClick={handleToggle2}>
                  {docStatusOptions[docStatusOptions.indexOf(contractBudgetrmData.site_budget_agreement_status)]}
                </Button>
                <Button
                  size="small"
                  aria-controls={open2 ? 'split-button-menu' : undefined}
                  aria-expanded={open2 ? 'true' : undefined}
                  aria-label="select merge strategy"
                  aria-haspopup="menu"
                  onClick={handleToggle2}
                >
                  <ArrowDropDownIcon />
                </Button>
              </ButtonGroup>
              <Popper
                open={open2}
                anchorEl={anchorRef2.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-start"
              >
                {({ TransitionProps, placement }) => (
                  <Grow {...TransitionProps}>
                    <Paper elevation={4}>
                      <ClickAwayListener onClickAway={handleClose2}>
                        <MenuList id="split-button-menu">
                          {docStatusOptions.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={index === 2}
                              selected={index === selectedIndex2}
                              onClick={event => handleMenuItemClick2(event, index)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
              <div />
              {budgetUpDoc.length > 1 ? (
                checkPermission('view_startUp_packet') ? (
                  budgetUpDoc
                    .slice(1)
                    .map((item: any, index: number) => (
                      <Chip
                        sx={{ m: 0.3, maxWidth: '50%' }}
                        key={index}
                        label={
                          archLevel == 'sponsor'
                            ? item.document_data.tmf_document_name
                            : item.document_data.isf_document_name
                        }
                        variant="outlined"
                        onClick={() => openDoucmentViewer(item)}
                        size="small"
                        color="primary"
                      />
                    ))
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </Grid>
        </Grid>

        {checkPermission('update_contract_budget') ? (
          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                <Button variant="text" id="myCheck" onClick={updateContractAndBudget}>
                  SAVE
                </Button>
              </Stack>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
      </Typography>
    </AccordionDetails>
  );
};

export default ContractandBudget;
